import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9c5ef8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onMouseenter", "onMouseleave", "onClick"]
const _hoisted_2 = {
  key: 0,
  class: "notifications-container"
}
const _hoisted_3 = {
  key: 0,
  class: "menu-item_title"
}

import {computed, ExtractPropTypes, AnchorHTMLAttributes, ref, PropType} from 'vue';
    import {NotificationBadge} from '@/logged/features/notifications';
    import {NavigationTab, NavigationTabAction, useAsideMenu} from '@/logged/features/aside-menu';
    import TootipWrapper from './TootipWrapper.vue';
    import {useDisplayMobile} from '@/logged/common/composables';
    import IconRenderer from '@/logged/common/ui/IconRenderer.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMenuItem',
  props: {
        tab: {type: Object as PropType<NavigationTab>},
        icon: String,
        title: String,
        showTitle: {type: Boolean, default: false},
        canBeActive: {type: Boolean, default: true},
        size: {type: Number, default: 20},
    },
  setup(__props) {

const props = __props;

    

    const isHovering = ref<boolean>(false);
    const asideMenuStore = useAsideMenu();
    const {isDisplayMobile} = useDisplayMobile();
    const getIcon = computed(() => (props.tab?.icons?.mainIcon ?? props.icon)!);
    const getTitle = computed(() => (props.tab?.title ?? props.title)!);

    const getComponentRoot = computed<'div' | 'a' | typeof TootipWrapper>(() => {
        if (props.tab?.tooltip) {
            return TootipWrapper;
        } else if (props.tab?.url?.href) {
            return 'a';
        }
        return 'div';
    });

    const isActive = computed(() => !!props.tab?.id && asideMenuStore.currentActiveRoute === props.tab.id);
    const getNotificationCount = computed(() => props.tab?.notificationsCount);

    const getComputedAttrs = computed<Partial<AnchorHTMLAttributes> | ExtractPropTypes<typeof TootipWrapper>>(() => {
        if (props.tab?.tooltip) {
            return {content: props.tab.tooltip, url: props.tab.url};
        } else if (props.tab?.url?.href) {
            return {
                href: props.tab.url.href,
                ...(props.tab.url.blank && {target: '_blank'}),
            };
        }
        return {};
    });

    const parentDropdownActive = ref<boolean>(false);
    const childDropdownActive = ref<Array<boolean>>([]);

    function setActiveParent(value: boolean) {
        if (props.tab?.children) {
            parentDropdownActive.value = value;
        } else {
            if (props.canBeActive) {
                isHovering.value = value;
            }
        }
    }
    function setActiveChild(index: number, value: boolean) {
        childDropdownActive.value[index] = value;
    }
    function getActiveChild(index: number) {
        return childDropdownActive.value[index];
    }
    function redirectTo(url: NavigationTabAction) {
        if (url.blank) {
            window.open(url.href);
        } else {
            window.location.href = url.href;
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (parentDropdownActive.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "menu-item__children joy-core-elevation-4",
          onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (setActiveParent(false))),
          onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (setActiveParent(true)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tab?.children, (child, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "menu-item__child joy-font-primary-300",
              onMouseenter: ($event: any) => (setActiveChild(index, true)),
              onMouseleave: ($event: any) => (setActiveChild(index, false)),
              onClick: ($event: any) => (child.url ? redirectTo(child.url) : child.action)
            }, [
              _createVNode(IconRenderer, {
                "can-be-active": __props.canBeActive,
                icon: child.icons?.mainIcon,
                name: child.title,
                size: 18,
                active: getActiveChild(index)
              }, null, 8, ["can-be-active", "icon", "name", "active"]),
              _createElementVNode("span", null, _toDisplayString(child.title), 1)
            ], 40, _hoisted_1))
          }), 128))
        ], 32))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentRoot.value), _mergeProps({ class: "menu-item flex" }, getComputedAttrs.value, {
      "aria-label": getTitle.value,
      "data-testid": __props.tab?.id,
      class: {isActive: isActive.value},
      onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (setActiveParent(true))),
      onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (setActiveParent(false)))
    }), {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["menu-item_icon-wrapper", {isActive: isActive.value}])
        }, [
          _createVNode(IconRenderer, {
            icon: getIcon.value,
            active: isActive.value || isHovering.value || parentDropdownActive.value,
            name: __props.tab?.id ?? getTitle.value,
            size: __props.size
          }, null, 8, ["icon", "active", "name", "size"]),
          (getNotificationCount.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_unref(NotificationBadge), {
                  count: getNotificationCount.value,
                  offset: 0
                }, null, 8, ["count"])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        (__props.showTitle && !_unref(isDisplayMobile))
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(getTitle.value), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16, ["aria-label", "data-testid", "class"]))
  ], 64))
}
}

})